import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styled from "styled-components";
import { getYear, getMonth } from "date-fns";

// Utility to generate year range
const range = (start, end, step) => {
  let result = [];
  for (let i = start; i <= end; i += step) {
    result.push(i);
  }
  return result;
};

// Styled components
const DatePickerWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  max-width: 300px;
`;

const Label = styled.label`
  position: absolute;
  top: -10px;
  left: 10px;
  background-color: white;
  padding: 0 5px;
  font-size: 13px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.4);
  z-index: 1;
`;

const StyledDatePicker = styled(DatePicker)`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 9px;
  box-sizing: border-box;
  font-size: 12px;
  color: #333;

  &::placeholder {
    color: rgba(0, 0, 0, 0.4);
    opacity: 1;
  }

  &:focus {
    outline: none;
    border: 2px solid #250258;
  }
`;

const CalendarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
`;

const NavigationButton = styled.button`
  background-color: #250258;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 14px;
  border-radius: 5px;
  &:hover {
    background-color: #5e0291;
  }
`;

const SelectDropdown = styled.select`
  background-color: #fff;
  color: #333;
  padding: 5px;
  border-radius: 5px;
  margin: 0 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  &:focus {
    outline: none;
    border-color: #250258;
  }
`;

const NormalDatePicker = ({ label, selected, onChange, maxDate, minDate, ...props }) => {
  const years = range(1980, getYear(new Date()) + 1, 1);
  const months = [
    "January", "February", "March", "April", "May", "June", 
    "July", "August", "September", "October", "November", "December",
  ];

  return (
    <DatePickerWrapper>
      {label && <Label>{label}</Label>}
      <StyledDatePicker
        selected={selected}
        onChange={onChange}
        dateFormat="MM/dd/yyyy"
        placeholderText="mm/dd/yyyy"
        filterDate={(date) => (maxDate ? date <= maxDate : true)} // Disable dates greater than maxDate
        maxDate={maxDate} // Pass the maxDate to DatePicker
        minDate={minDate} // Disable dates less than minDate
        renderCustomHeader={({
          date,
          changeYear,
          changeMonth,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <CalendarHeader>
            <NavigationButton onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
              {"<"}
            </NavigationButton>
            <SelectDropdown
              value={getYear(date)}
              onChange={({ target: { value } }) => changeYear(value)}
            >
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </SelectDropdown>
            <SelectDropdown
              value={months[getMonth(date)]}
              onChange={({ target: { value } }) =>
                changeMonth(months.indexOf(value))
              }
            >
              {months.map((month) => (
                <option key={month} value={month}>
                  {month}
                </option>
              ))}
            </SelectDropdown>
            <NavigationButton onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
              {">"}
            </NavigationButton>
          </CalendarHeader>
        )}
        showYearDropdown
        scrollableYearDropdown
        yearDropdownItemNumber={50}
        {...props}
      />
    </DatePickerWrapper>
  );
};

export default NormalDatePicker;
